/* Loom Loom — landing page interactions */
(function () {
  // Sticky nav border on scroll
  var nav = document.querySelector('[data-llom-nav]');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 8) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // If a Shopify customer form posted successfully, the URL gains
  // ?customer_posted=true on a server-side redirect. Auto-scroll to
  // the form that posted so the success message is visible on mobile.
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    var target = document.querySelector('.capture-success');
    if (target) {
      try {
        target.parentElement &&
          target.parentElement.getBoundingClientRect &&
          window.scrollTo({
            top: window.pageYOffset + target.getBoundingClientRect().top - 80,
            behavior: 'smooth'
          });
      } catch (e) {}
    }
  }
})();
